import styled from 'styled-components';
import Box from '@mui/material/Box';

import { GRADIENT_STYLES } from '../ConnectionsList/FeaturedSection/styled';

export const StyledLoadingFeaturedItem = styled(Box)`
  ${GRADIENT_STYLES}
`;
